import { getCurrentUser } from '../services/api';

const GUEST_PREFIX = 'guest';

/** Prefix storage key dengan userId agar data tidak tertukar antar akun. */
export function getUserStoragePrefix() {
  const user = getCurrentUser();
  const id = user?._id || user?.id;
  return id ? String(id) : GUEST_PREFIX;
}

export function userStorageKey(key) {
  return `ds:${getUserStoragePrefix()}:${key}`;
}

export function userGetItem(key) {
  try {
    return localStorage.getItem(userStorageKey(key));
  } catch {
    return null;
  }
}

export function userSetItem(key, value) {
  try {
    localStorage.setItem(userStorageKey(key), value);
    return true;
  } catch {
    return false;
  }
}

export function userRemoveItem(key) {
  try {
    localStorage.removeItem(userStorageKey(key));
    return true;
  } catch {
    return false;
  }
}

/** Migrasi key global lama ke namespace per-user (sekali). */
export function migrateLegacyKey(legacyKey, userKey = legacyKey) {
  try {
    const namespaced = userStorageKey(userKey);
    if (localStorage.getItem(namespaced)) return;

    const legacy = localStorage.getItem(legacyKey);
    if (legacy) {
      localStorage.setItem(namespaced, legacy);
      localStorage.removeItem(legacyKey);
    }
  } catch {
    // abaikan — localStorage mungkin penuh / diblokir
  }
}
